/* eslint-disable react/prop-types */

export const PLACEHOLDER_IMG = `${process.env.PUBLIC_URL}/assets/sinimagen.gif`;

export const normalizar = (valor = '') =>
    valor
        .toString()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();

export const tienePrecio = (art) => art.Precio !== undefined && art.Precio !== null && art.Precio !== '';

export const tituloArticulo = (art) => art.Nombre || art.Parte_fabricante || art.Alias;

export const urlImagen = (art) => {
    const primera = art.Imagenes ? art.Imagenes.split(',')[0].trim() : '';
    return primera
        ? `${process.env.PUBLIC_URL}/articulos/thumbs/${encodeURIComponent(primera)}`
        : PLACEHOLDER_IMG;
};

export const urlDetalle = (art) => `/detalle?sku=${encodeURIComponent(String(art.Alias).replace(/ç/g, ''))}`;

export const formatearPrecio = (valor) => {
    const num = typeof valor === 'number' ? valor : parseFloat(valor);
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Devuelve [1, '…', 7, 8, 9, '…', 120]; con pocas paginas devuelve todas
export const paginasConPuntos = (actual, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const set = new Set([1, total, actual - 1, actual, actual + 1]);
    const orden = [...set].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    const salida = [];
    orden.forEach((n, i) => {
        if (i > 0 && n - orden[i - 1] > 1) salida.push(`…${i}`);
        salida.push(n);
    });
    return salida;
};
